/* Badan Studios — Localizador de tiendas con mapa real (Leaflet + teselas configurables).
   Lee las tiendas de la lista (data-lat/data-lng), las pinta agrupadas, y conecta lista ↔ mapa,
   búsqueda y "cerca de mí" (geolocalización del navegador, solo si el usuario la permite). */
(function () {
  'use strict';

  function init(root) {
    var L = window.L;
    var mapEl = root.querySelector('[data-store-map]');
    if (!L || !mapEl) return;

    var list = root.querySelector('[data-store-list]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-store]'));
    var countEl = root.querySelector('[data-store-count]');
    var emptyEl = root.querySelector('[data-store-empty]');
    var statusEl = root.querySelector('[data-store-status]');
    var searchInput = root.querySelector('[data-store-search]');
    var hintEl = root.querySelector('[data-map-hint]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---- Mapa ----
    var map = L.map(mapEl, {
      zoomControl: false,
      scrollWheelZoom: false, // se activa al hacer clic en el mapa para no secuestrar el scroll de la página
      worldCopyJump: true,
      minZoom: 2,
      maxZoom: 19
    });
    L.control.zoom({ position: 'topright' }).addTo(map);
    mapEl.badanMap = map; // acceso para depuración desde la consola
    L.tileLayer(root.dataset.tiles, {
      maxZoom: 19,
      attribution: root.dataset.attribution,
    }).addTo(map);
    map.attributionControl.setPrefix(false);

    map.on('click', function () {
      map.scrollWheelZoom.enable();
      if (hintEl) hintEl.hidden = true;
    });
    mapEl.addEventListener('mouseleave', function () { map.scrollWheelZoom.disable(); });

    // ---- Marcadores ----
    var PIN_HTML =
      '<svg viewBox="-13 -36 26 37" width="30" height="42" aria-hidden="true">' +
      '<path class="store-pin__shape" d="M0 0C-3-6-11-11-11-19a11 11 0 0 1 22 0C11-11 3-6 0 0Z"/>' +
      '<circle class="store-pin__hole" cx="0" cy="-19" r="3.8"/></svg>';

    function pinIcon(active) {
      return L.divIcon({
        className: 'store-pin' + (active ? ' is-active' : ''),
        html: PIN_HTML,
        iconSize: [30, 42],
        iconAnchor: [15, 41],
        popupAnchor: [0, -38]
      });
    }

    var cluster = L.markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 48,
      disableClusteringAtZoom: 15,
      spiderfyDistanceMultiplier: 1.6,
      iconCreateFunction: function (c) {
        var n = c.getChildCount();
        return L.divIcon({
          className: 'store-cluster',
          html: '<span aria-label="' + (root.dataset.clusterLabel || '').replace('{{ count }}', n) + '">' + n + '</span>',
          iconSize: [44, 44]
        });
      }
    });

    var stores = [];
    var byId = {};

    function text(item, sel) {
      var el = item.querySelector(sel);
      return el ? el.textContent.trim() : '';
    }

    function popupHtml(item) {
      var wrap = document.createElement('div');
      wrap.className = 'store-popup__body';
      var n = document.createElement('p');
      n.className = 'store-popup__name';
      n.textContent = text(item, '.store-item__name');
      var p = document.createElement('p');
      p.className = 'store-popup__place';
      p.textContent = text(item, '.store-item__place');
      wrap.appendChild(n);
      wrap.appendChild(p);
      var address = text(item, '.store-item__address');
      if (address) {
        var ad = document.createElement('p');
        ad.className = 'store-popup__place';
        ad.textContent = address;
        wrap.appendChild(ad);
      }
      var actions = document.createElement('div');
      actions.className = 'store-popup__actions';
      var dir = item.querySelector('[data-store-directions]');
      if (dir) {
        var a = document.createElement('a');
        a.className = 'button store-popup__button';
        a.href = dir.href;
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = dir.textContent.trim() + ' →';
        actions.appendChild(a);
      }
      var web = item.querySelector('[data-store-web]');
      if (web) {
        var w = document.createElement('a');
        w.className = 'store-popup__link';
        w.href = web.href;
        w.target = '_blank';
        w.rel = 'noopener';
        w.textContent = web.textContent.trim();
        actions.appendChild(w);
      }
      wrap.appendChild(actions);
      return wrap;
    }

    items.forEach(function (item) {
      var lat = parseFloat(String(item.dataset.lat).replace(',', '.'));
      var lng = parseFloat(String(item.dataset.lng).replace(',', '.'));
      if (isNaN(lat) || isNaN(lng)) return;
      var marker = L.marker([lat, lng], {
        icon: pinIcon(false),
        title: text(item, '.store-item__name'),
        riseOnHover: true
      });
      marker.bindPopup(function () { return popupHtml(item); }, {
        className: 'store-popup',
        closeButton: true,
        maxWidth: 280,
        autoPanPadding: [24, 24]
      });
      var store = { id: item.dataset.id, lat: lat, lng: lng, item: item, marker: marker };
      marker.on('click', function () { activate(store, true); });
      marker.on('popupclose', function () {
        if (active === store) deactivate();
      });
      stores.push(store);
      byId[store.id] = store;
    });

    cluster.addLayers(stores.map(function (s) { return s.marker; }));
    map.addLayer(cluster);

    // ---- Encuadre ----
    function visibleStores() {
      return stores.filter(function (s) { return !s.item.hidden; });
    }

    function fitStores(list, animate) {
      if (!list.length) return;
      if (list.length === 1) {
        map.setView([list[0].lat, list[0].lng], 14, { animate: animate && !reduceMotion });
        return;
      }
      var bounds = L.latLngBounds(list.map(function (s) { return [s.lat, s.lng]; }));
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 13, animate: animate && !reduceMotion });
    }

    if (stores.length) fitStores(stores, false);
    else map.setView([40.2, -3.7], 5);

    var resetBtn = root.querySelector('[data-map-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        map.closePopup();
        fitStores(visibleStores(), true);
      });
    }

    // ---- Selección (lista ↔ mapa) ----
    var active = null;

    function activate(store, fromMap) {
      if (active && active !== store) {
        active.item.classList.remove('is-active');
        active.marker.setIcon(pinIcon(false));
      }
      active = store;
      store.item.classList.add('is-active');
      store.marker.setIcon(pinIcon(true));
      if (fromMap && list) {
        list.scrollTo({ top: store.item.offsetTop - list.offsetTop - 8, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    function deactivate() {
      if (!active) return;
      active.item.classList.remove('is-active');
      active.marker.setIcon(pinIcon(false));
      active = null;
    }

    function focusStore(store) {
      activate(store, false);
      var zoom = Math.max(map.getZoom(), 15);
      var center = map.getCenter();
      var alreadyThere = map.getZoom() >= 15 && center.distanceTo([store.lat, store.lng]) < 30;
      if (alreadyThere || reduceMotion) {
        map.setView([store.lat, store.lng], zoom, { animate: false });
        store.marker.openPopup();
      } else {
        map.once('moveend', function () { store.marker.openPopup(); });
        map.flyTo([store.lat, store.lng], zoom, { duration: 0.9 });
      }
      if (window.matchMedia('(max-width: 989px)').matches) {
        mapEl.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-store-select]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var store = byId[item.dataset.id];
        userMoved = true;
        if (store) focusStore(store);
      });
    });

    // ---- Búsqueda ----
    function normalize(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }

    function applySearch() {
      var q = normalize(searchInput ? searchInput.value.trim() : '');
      var visible = [];
      items.forEach(function (item) {
        var show = !q || normalize(item.dataset.search).indexOf(q) !== -1;
        item.hidden = !show;
      });
      stores.forEach(function (s) { if (!s.item.hidden) visible.push(s); });
      cluster.clearLayers();
      cluster.addLayers(visible.map(function (s) { return s.marker; }));
      if (active && active.item.hidden) {
        map.closePopup();
        deactivate();
      }
      var count = items.filter(function (i) { return !i.hidden; }).length;
      if (countEl) countEl.textContent = count;
      if (emptyEl) emptyEl.hidden = count !== 0;
      return visible;
    }

    var searchTimer;
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          var visible = applySearch();
          if (visible.length) fitStores(visible, true);
        }, 200);
      });
    }

    // ---- Cerca de mí ----
    var nearBtn = root.querySelector('[data-store-near]');
    var youMarker = null;

    function showStatus(msg) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
      statusEl.hidden = !msg;
    }

    function haversine(lat1, lng1, lat2, lng2) {
      var toRad = Math.PI / 180;
      var dLat = (lat2 - lat1) * toRad;
      var dLng = (lng2 - lng1) * toRad;
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * 6371 * Math.asin(Math.sqrt(a));
    }

    function formatKm(d) {
      return (d < 10 ? d.toFixed(1).replace('.', ',') : Math.round(d).toLocaleString('es-ES')) + ' km';
    }

    if (nearBtn) {
      nearBtn.addEventListener('click', function () {
        if (!navigator.geolocation) {
          showStatus(root.dataset.geoUnsupported);
          return;
        }
        showStatus(root.dataset.geoLoading);
        nearBtn.disabled = true;
        navigator.geolocation.getCurrentPosition(function (pos) {
          nearBtn.disabled = false;
          showStatus('');
          var lat = pos.coords.latitude;
          var lng = pos.coords.longitude;

          stores.forEach(function (s) { s.distance = haversine(lat, lng, s.lat, s.lng); });
          stores.slice().sort(function (a, b) { return a.distance - b.distance; }).forEach(function (s) {
            list.appendChild(s.item);
            var dEl = s.item.querySelector('[data-store-distance]');
            if (dEl) {
              dEl.textContent = formatKm(s.distance);
              dEl.hidden = false;
            }
          });
          if (searchInput) searchInput.value = '';
          applySearch();
          list.scrollTo({ top: 0 });

          if (!youMarker) {
            youMarker = L.marker([lat, lng], {
              icon: L.divIcon({ className: 'store-you', html: '<span></span>', iconSize: [22, 22] }),
              title: root.dataset.youLabel,
              zIndexOffset: -100,
              keyboard: false
            }).addTo(map);
          } else {
            youMarker.setLatLng([lat, lng]);
          }

          // Encuadra al usuario con sus 3 tiendas más cercanas
          var nearest = stores.slice().sort(function (a, b) { return a.distance - b.distance; }).slice(0, 3);
          if (nearest.length) {
            var bounds = L.latLngBounds([[lat, lng]].concat(nearest.map(function (s) { return [s.lat, s.lng]; })));
            map.fitBounds(bounds, { padding: [50, 50], maxZoom: 14, animate: !reduceMotion });
            activate(nearest[0], true);
          }
        }, function () {
          nearBtn.disabled = false;
          showStatus(root.dataset.geoError);
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
      });
    }

    // Si el contenedor cambia de tamaño (p. ej. rotar el móvil), recalcular y, mientras el usuario
    // no haya movido el mapa, volver a encuadrar todas las tiendas.
    var userMoved = false;
    mapEl.addEventListener('pointerdown', function () { userMoved = true; });
    if ('ResizeObserver' in window) {
      var resizeTimer;
      new ResizeObserver(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          map.invalidateSize();
          if (!userMoved && !active) fitStores(visibleStores(), false);
        }, 120);
      }).observe(mapEl);
    }
  }

  function boot() {
    document.querySelectorAll('[data-store-locator]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
